import React, { useEffect, useState } from 'react';
import Axios from '../../utils/axios';
import { defaultPageSize } from '../../utils/const';
import CatalogTableC from '../../components/Catalogs/CatalogTableC';
import PaginatedTable from "../../components/Organismos/Table/PaginatedTable";
import { Link } from 'react-router-dom';
import ShapeEdit from '../../components/Atomos/Icons/ShapeEdit';
import { IPagination2, ISorting } from '../../interfaces/Components/ITable';
import { exportAllDataLoader2 } from "../../utils/exportAllDataLoader2";

const WSG: React.FC = ({ ...props }) => {
  const axios = new Axios();
  const [data, setData] = useState<any[]>([]);
  const [sort, setSort] = useState<ISorting>({ field: "_ts", order: "asc" });
  const [pagination, setPagination] = useState<IPagination2>({ pageIndex: 0, pageSize: defaultPageSize });
  const [totalCount, setTotalCount] = useState<number>(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const queryParams: string[] = [];

        let queryString = '/WSG';
        if (queryParams.length > 0) {
          queryString += `?${queryParams.join('&')}`;
        }
        console.log(queryString);
        const response = await axios.Get(queryString);
        const data = response.data;
        if (data != null) {
          setData(data);
        }
      } catch (error) {
        console.error('Error al obtener la información de la columna:', error);
      }
    };
    fetchData();
  }, [sort]);

  const columnsDef = React.useMemo(() => [
    {
      id: "count",
      header: "#",
      enableSorting: false,
      cell: ({ rowIndex }: { rowIndex: number; row: any; value: any }) => (
        <p> {rowIndex + 1 + pagination.pageIndex * pagination.pageSize} </p>
      ),
    },
    { id: 'name', header: 'Name' },
    { id: 'createdDate', header: "Created Date" },
    {
      id: 'edit',
      header: 'Edit',
      enableSorting: false,
      cell: ({ row }: { rowIndex: number; row: any; value: any }) => (
        <Link
          className="edit"
          to={`Edit/${row.id}`}
          state={row}
        >
          Edit
          <div className="editsvg">
            <ShapeEdit/>
          </div>
        </Link>
      ),
    },
  ], [pagination.pageIndex, pagination.pageSize]);

  return (
          <CatalogTableC
            title={`City Catalog`}
            catalogName={"WSG"}
            route={"City"}
            totalCount={totalCount}
            noNewCatalog
          >
            <PaginatedTable
              data={data || []}
              columnsDef={columnsDef}
              sorting={sort}
              onSortingChange={setSort}
              totalCount={totalCount || 0}
              pagination={pagination}
              onPaginationChange={setPagination}
              // En este catálogo ya cargamos TODO en `data`, así que "All Data" = current data.
              onExportAll={async () => data || []}
            />
          </CatalogTableC>
    );
};

export default WSG;
